export default () => {
  const container = document.querySelector('.js-options-rubber')
  if (!container) return

  const trigger = container.querySelector('.js-options-rubber--trigger')
  const width = document.querySelector('.js-woo-width')
    ? document.querySelector('.js-woo-width')
    : false
  const height = document.querySelector('.js-woo-length')
    ? document.querySelector('.js-woo-length')
    : false
  const defaultDimensions = document.querySelector('.js-woo-default-select')
    ? document.querySelector('.js-woo-default-select')
    : false
  const matPrices = document.querySelector('.js-woo-rubber-mat-price')
    ? document.querySelectorAll('.js-woo-rubber-mat-price')
    : false

  trigger.addEventListener('click', e => {
    console.log('Clicked on product option: Rubber')

    if ((width.value && height.value) || defaultDimensions.value) {
      container.classList.remove('active-error')

      if (container.classList.contains('active')) {
        container.classList.remove('active')
      } else {
        container.classList.add('active')
      }
    } else {
      if (container.classList.contains('active-error')) {
        container.classList.remove('active-error')
        container.classList.remove('active')
      } else {
        container.classList.add('active-error')
        container.classList.add('active')
      }

      if (matPrices) {
        ;[...matPrices].forEach(matPrice => {
          matPrice.innerHTML = '€0,00'
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/ProductOptionRubber.js